module.exports = __webpack_public_path__ + "static/media/logoDelfos-white.c928e0fd.svg";